import { useMergeGoalLinkChanges, useUpdateGoal } from 'features/goals';
import { useCallback } from 'react';
import { rootId } from 'shared/components/ui/virtualized-tree-list';
import {
  Goal,
  GoalLifeAreaLinkChange,
  GoalParentLinkChange,
  UpdateGoal,
} from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { GoalSortingMode } from 'shared/types/sorting-mode';

// Parallel to useLifeAreaGoalReorder / useGoalOverviewReorder: persists to the goal's own goalSorting.
export const useSubGoalReorder = (goal: Goal) => {
  const { submit: updateGoal } = useUpdateGoal();
  const mergeGoalLinkChanges = useMergeGoalLinkChanges();

  return useCallback(
    (
      updatedSections: { id: ID; goalSorting: ID[] }[],
      updatedGoals: UpdateGoal[],
      _goalLinkChanges?: GoalLifeAreaLinkChange[],
      goalParentChanges: GoalParentLinkChange[] = [],
    ) => {
      mergeGoalLinkChanges(updatedGoals, { goalParentChanges }).forEach(
        (goalUpdate) => updateGoal(goalUpdate),
      );

      updatedSections.forEach(({ id, goalSorting }) => {
        if (id === rootId) {
          updateGoal({
            id: goal.id,
            goalSorting,
            goalSortingMode: GoalSortingMode.Custom,
          });
          return;
        }
        // there should be nothing here
      });
    },
    [goal.id, mergeGoalLinkChanges, updateGoal],
  );
};
